import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { axInst } from "../../../Components/Login/Service";
import TanstackTable from "../../../Components/Table/TanstackTable";

const CustomerComplaint = () => {
  const selectedFilter = useSelector(
    (state) => state.filtersPvin.selectedFilter
  );

  const fetchComplaints = async (filter) => {
    const res = await axInst.post("pvin/complaint", filter);
    return res.data;
  };

  const columns = useMemo(
    () => [
      {
        header: "Complaint",
        accessorKey: "Area_Name",
        cell: ({ getValue }) => (
          <div className="text-left">{getValue() || "N/A"}</div>
        ),
      },
      { header: "Total Complaints ", accessorKey: "Total_Complaints" },
      { header: "Open Complaints ", accessorKey: "Open_Complaints" },
    ],
    []
  );

  return (
    <TanstackTable
      heading="Customer Complaints"
      columns={columns}
      apiFn={fetchComplaints}
      queryKey="complaintSummary"
      filter={selectedFilter}
      theadColor="bg-white"
      height="max-h-[250px]"
      theadCss="text-gray-700 font-semibold text-lg text-left"
      border=""
    />
  );
};

export default CustomerComplaint;
